import React from 'react';
import { CheckCircle2, Clock, Target, Receipt, Banknote } from 'lucide-react';
import styles from './ExpenseMetrics.module.css';

const inr = (n) => `₹${(Number(n) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

const ExpenseMetrics = ({ metrics }) => {
    const m = {
        approved: Number(metrics?.approvedAmt || 0),
        pending: Number(metrics?.pendingAmt || 0),
        planned: Number(metrics?.plannedAmt || 0),
        total: Number(metrics?.totalAmt || 0),
        pendingCount: Number(metrics?.pendingCount || 0),
        cash: Number(metrics?.cashPaidAmt || 0),
        online: Number(metrics?.onlinePaidAmt || 0),
    };

    return (
        <div className={styles.metricsGrid}>
            <div className={`${styles.metricCard} ${styles.cardCash}`}>
                <div className={styles.metricHeader}>
                    <span className={styles.metricLabel}>Paid from cash drawer</span>
                    <div className={`${styles.iconBg} ${styles.bgDanger}`}><Banknote size={15} /></div>
                </div>
                <div className={styles.metricValue}>{inr(m.cash)}</div>
                <div className={styles.metricSub}>Online / bank {inr(m.online)}</div>
            </div>

            <div className={styles.metricCard}>
                <div className={styles.metricHeader}>
                    <span className={styles.metricLabel}>Approved (paid)</span>
                    <div className={`${styles.iconBg} ${styles.bgSuccess}`}><CheckCircle2 size={15} /></div>
                </div>
                <div className={styles.metricValue}>{inr(m.approved)}</div>
            </div>

            <div className={`${styles.metricCard} ${m.pendingCount > 0 ? styles.cardHighlight : ''}`}>
                <div className={styles.metricHeader}>
                    <span className={styles.metricLabel}>Pending approval</span>
                    <div className={`${styles.iconBg} ${styles.bgWarning}`}><Clock size={15} /></div>
                </div>
                <div className={styles.metricValue}>{inr(m.pending)}</div>
                {m.pendingCount > 0 && <div className={styles.metricSub}>{m.pendingCount} {m.pendingCount === 1 ? 'expense needs' : 'expenses need'} review</div>}
            </div>

            <div className={styles.metricCard}>
                <div className={styles.metricHeader}>
                    <span className={styles.metricLabel}>Planned budgets</span>
                    <div className={`${styles.iconBg} ${styles.bgPrimary}`}><Target size={15} /></div>
                </div>
                <div className={styles.metricValue}>{inr(m.planned)}</div>
                <div className={styles.metricSub}>Not spent yet</div>
            </div>

            <div className={styles.metricCard}>
                <div className={styles.metricHeader}>
                    <span className={styles.metricLabel}>Total tracked</span>
                    <div className={`${styles.iconBg} ${styles.bgPrimary}`}><Receipt size={15} /></div>
                </div>
                <div className={styles.metricValue}>{inr(m.total)}</div>
            </div>
        </div>
    );
};

export default ExpenseMetrics;
